export default {
    insertProofPayment: {
        url: 'debtor/saveProofPayment', 
        method: 'post', 
    },
    listTypeProofPayment:{
        url: 'debtor/listTypeProofPayment', 
        method: 'get',  
    },
    statusProofPayment: {
        url: 'debtor/getProofPaymentStatus',
        method: 'post',
    }
}